// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__MQgEb","textRow":"styles_textRow__kgNVh","text":"styles_text__YmUFN","item":"styles_item__FaphS","icon":"styles_icon__wBwIL"};